<template>
  <div>
    <Button
      type="primary"
      v-hasPermission="['alarm_contact:AlarmContactGroup:create']"
      @click="modal = true"
      >{{ $t("alarm_contact.addContact") }}</Button
    >
    <Modal
      v-model="modal"
      :title="$t('alarm_contact.addContact')"
      :loading="loading"
      @on-ok="alarmContactGroupSubmit('alarmContactGroupForm')"
      @on-cancel="alarmContactGroupReset('alarmContactGroupForm')"
      :mask-closable="false"
      :okText="$t('alarms.common.add')"
      :cancelText="$t('alarms.common.cancel')"
    >
      <Form
        ref="alarmContactGroupForm"
        :model="alarmContactGroupForm"
        :label-width="120"
        :rules="ruleValidate"
      >
        <!-- 公司 -->
        <div v-if="company == 1">
          <FormItem :label="$t('alarm_contact.companyName')" prop="companyId">
            <Select
              filterable
              v-model="companyId"
              style="width:300px;"
              placeholder=""
            >
              <Option
                :value="item.id"
                v-for="(item, index) in companyList"
                v-bind:key="index"
                >{{ item.name }}
              </Option>
            </Select>
          </FormItem>
        </div>
        <!-- 联系人组名称 -->
        <FormItem :label="$t('alarm_contact.contactGroupName')" prop="name">
          <Input v-model="alarmContactGroupForm.name" style="width:300px;" />
        </FormItem>

        <!-- 默认联系人组 -->
        <FormItem :label="$t('alarm_contact.defaultContact')" prop="isDefault">
          <RadioGroup v-model="alarmContactGroupForm.isDefault">
            <Radio
              v-for="list in isDefaultList"
              :label="list.isDefault"
              :key="list.value"
              >{{ list.label }}</Radio
            >
          </RadioGroup>
        </FormItem>

        <!-- 描述 -->
        <FormItem :label="$t('alarm_contact.description')" prop="description">
          <Input
            v-model="alarmContactGroupForm.description"
            type="textarea"
            :autosize="{ minRows: 2, maxRows: 5 }"
            placeholder=""
            style="width:300px;"
          ></Input>
        </FormItem>
      </Form>
    </Modal>
  </div>
</template>
<script>
import { setCookie, getCookie } from "../../../utils/cookieUtil.js";
import TableAlarmContactGroup from "../alarm_contact_group/TableAlarmContactGroup.vue";
var tableAlarmContactGroup = TableAlarmContactGroup;
export default {
  data() {
    return {
      company: getCookie(global.companyId),
      companyId: "",
      companyList: [],
      alarmContactGroupForm: {
        name: "",
        description: "",
        isDefault: "0"
      },
      isDefaultList: [
        {
          label: this.$t("alarm_contact.yes"),
          value: "is",
          isDefault: "1"
        },
        {
          label: this.$t("alarm_contact.no"),
          value: "no",
          isDefault: "0"
        }
      ],
      loading: true,
      modal: false,
      ruleValidate: {
        name: [
          { required: true, message: "请输入联系人组名称", trigger: "blur" }
        ],
        isDefault: [
          { required: true, message: "请选择默认联系人组", trigger: "change" }
        ],
        description: [
          { required: true, message: "请输入描述", trigger: "blur" }
        ]
      }
    };
  },
  mounted: function() {
    if (this.company == 1) {
      this.getCompanyDropDownBox();
    }
  },
  methods: {
    // 获取公司下拉框
    getCompanyDropDownBox: function() {
      this.$api.company
        .getCompanyDropDownBox("userName", getCookie(global.cookieName))
        .then(res => {
          this.companyList = res.data;
        });
    },
    alarmContactGroupSubmit: function(name) {
      this.$refs[name].validate(valid => {
        if (valid) {
          // 添加联系人组
          this.$api.contactGroup
            .createContactGroup({
              companyId:
                this.companyId == null ||
                this.companyId == "" ||
                this.companyId == undefined
                  ? this.company
                  : this.companyId,
              name: this.alarmContactGroupForm.name,
              isDefault: this.alarmContactGroupForm.isDefault,
              description: this.alarmContactGroupForm.description
            })
            .then(res => {
              setTimeout(() => {
                tableAlarmContactGroup.methods.showAll();
                this.$refs[name].resetFields();
                this.loading = false;
                this.$nextTick(() => {
                  this.loading = true;
                });
                this.$Message.success("添加成功");
                this.modal = false;
              }, 1000);
            });
        } else {
          //解决iview 表单验证，验证提示error完成验证后，"确定"按钮一直转圈，点击不起作用问题
          this.loading = false;
          setTimeout(() => {
            this.loading = true;
          }, 0);
          this.$Message.error("添加失败");
        }
      });
    },
    alarmContactGroupReset: function(name) {
      this.$refs[name].resetFields();
    }
  }
};
</script>
<style scoped></style>



// WEBPACK FOOTER //
// src/components/alarm_contact/alarm_contact_group/AddAlarmContactGroup.vue